import { translate } from "@components/translations/Translations";

export const getEducationalTrackWords = (str: string): string | undefined => {
    if (!str || str === "NOT_APPLICABLE") {
        return;
    }

    const tmpArr = str.split("_");
    const tmp = `(${tmpArr[0].charAt(0).toUpperCase()}${tmpArr[0].slice(1).toLowerCase()} ${tmpArr[1].charAt(0).toUpperCase()}${tmpArr[1].slice(1).toLowerCase()})`;

    return tmp;
};

export const getKinderWords = (arrOrString: string, lang: string): string | undefined => {
    if (!arrOrString) {
        return;
    }
    const arrayFromStr = arrOrString.split(",");
    if (Array.isArray(arrayFromStr) && arrayFromStr?.length > 1) {
        const strArr = arrayFromStr.map((item) => {
            if (item === "K_HALF_AM") {
                return translate("OEApp_HalfDayAM", lang) as string;
            }
            if (item === "K_HALF_PM") {
                return translate("OEApp_HalfDayPM", lang) as string;
            }
            if (item === "K_FULL") {
                return translate("OEApp_FullDay", lang) as string;
            }

            return item;
        });

        return strArr.join(", ");
    }

    if (arrOrString === "K_HALF_AM") {
        return translate("OEApp_HalfDayAM", lang) as string;
    }
    if (arrOrString === "K_HALF_PM") {
        return translate("OEApp_HalfDayPM", lang) as string;
    }
    if (arrOrString === "K_FULL") {
        return translate("OEApp_FullDay", lang) as string;
    }

    return arrOrString;
};

export const getLanguageWords = (arrOrString: string, lang: string): string | undefined => {
    if (!arrOrString) {
        return;
    }
    const arrayFromStr = arrOrString.split(",");
    if (Array.isArray(arrayFromStr) && arrayFromStr?.length > 1) {
        const strArr = arrayFromStr.map((item) => {
            if (item === "ENGLISH") {
                return translate("OEApp_English", lang) as string;
            }
            if (item === "FRENCH") {
                return translate("OEApp_French", lang) as string;
            }
            if (item === "MANDARIN") {
                return translate("OEApp_Mandarin", lang) as string;
            }
            if (item === "SPANISH") {
                return translate("OEApp_Spanish", lang) as string;
            }

            return item;
        });

        return strArr.join(", ");
    }

    return `${arrOrString.charAt(0).toUpperCase()}${arrOrString.slice(1).toLowerCase()}`;
};

export const getStatusWords = (status: string, lang: string): string => {
    switch (status) {
        case "ACCEPT_OFFER":
            return translate("OEApp_ACCEPT_OFFER", lang) as string;
        case "CANCELLED_REQUEST":
            return translate("OEApp_CANCELLED_REQUEST", lang) as string;
        case "CHANGED_ENROLLMENT":
            return translate("OEApp_CHANGED_ENROLLMENT", lang) as string;
        case "CHOICE_CREATED":
            return translate("OEApp_CHOICE_CREATED", lang) as string;
        case "CHOICE_INCOMPLETE":
            return translate("OEApp_CHOICE_INCOMPLETE", lang) as string;
        case "DENY_OFFER":
            return translate("OEApp_DENY_OFFER", lang) as string;
        case "DENY_REQUEST":
            return translate("OEApp_DENY_REQUEST", lang) as string;
        case "ENROLLED":
            return translate("OEApp_ENROLLED", lang) as string;
        case "INVALID":
            return translate("OEApp_INVALID", lang) as string;
        case "MAKE_OFFER":
            return translate("OEApp_MAKE_OFFER", lang) as string;
        case "MAKE_OFFER_PENDING":
            return translate("OEApp_MAKE_OFFER_PENDING", lang) as string;
        case "NO_RESPONSE":
            return translate("OEApp_NO_RESPONSE", lang) as string;
        case "WAIT_LIST":
            return translate("OEApp_WAIT_LIST", lang) as string;
        case "REQUEST":
            return translate("OEApp_REQUEST", lang) as string;
        case "UNENROLLED":
            return translate("OEApp_UNENROLLED", lang) as string;
        default:
            return translate("OEApp_UNAVAILABLE", lang) as string;
    }
};
